import { render, staticRenderFns } from "./DictationButton.vue?vue&type=template&id=6edd9499&scoped=true&"
import script from "./DictationButton.vue?vue&type=script&lang=ts&"
export * from "./DictationButton.vue?vue&type=script&lang=ts&"
import style0 from "./DictationButton.vue?vue&type=style&index=0&id=6edd9499&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd9499",
  null
  
)

export default component.exports